import * as Linking from 'expo-linking';
import * as WebBrowser from 'expo-web-browser';

const onMessage = (e) => {
	const { href, action } = JSON.parse(e.nativeEvent.data);
	if (action !== 'navigate') {
		return;
	}
	if (href.match(/tel|mailto/)) {
		Linking.openURL(href);
	} else {
		WebBrowser.openBrowserAsync(href);
	}
};
export default onMessage;